import React from "react";
//5889
import { Autocomplete } from "formik-mui";
import TextField from "@mui/material/TextField";
import { Field, useFormikContext } from "formik";
import propTypes from "prop-types";

export default function BrandAutoComplete({ brandTypes }) {
  const { touched, errors } = useFormikContext();

  const brandIDValidationSchema = (value) => {
    return value ? null : "Required";
  };

  return (
    <Field
      fullWidth={true}
      name="brand_id"
      validate={brandIDValidationSchema}
      component={Autocomplete}
      options={brandTypes.data}
      getOptionLabel={(option) => option?.name || ""}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      renderOption={(props, option) => {
        const { key, ...liProps } = props;
        return (
          <li {...liProps} key={option?.id ?? `${option?.name}-${option?.code ?? ""}`}>
            {option?.name}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          error={touched["brand_id"] && !!errors["brand_id"]}
          helperText={
            touched["brand_id"] && !!errors["brand_id"]
              ? errors["brand_id"]
              : ""
          }
          {...params}
          label="Brand name"
          variant="filled"
        />
      )}
    />
  );
}

BrandAutoComplete.propTypes = {
  brandTypes: propTypes.object,
};